import { useIntl } from 'react-intl';
import { useLanguageContext } from 'providers/language';

const renderDataGridLocaleText = () => {
  /* eslint-disable react-hooks/rules-of-hooks */
  const intl = useIntl();
  const { language } = useLanguageContext();
  /* eslint-enable react-hooks/rules-of-hooks */

  return {
    // Density selector toolbar button text
    toolbarDensity: intl.formatMessage({ id: 'datagrid.toolbarDensity', defaultMessage: 'Yoğunluk' }),
    toolbarDensityLabel: intl.formatMessage({ id: 'datagrid.toolbarDensityLabel', defaultMessage: 'Yoğunluk' }),
    toolbarDensityCompact: intl.formatMessage({ id: 'datagrid.toolbarDensityCompact', defaultMessage: 'Sıkı' }),
    toolbarDensityStandard: intl.formatMessage({ id: 'datagrid.toolbarDensityStandard', defaultMessage: 'Standart' }),
    toolbarDensityComfortable: intl.formatMessage({
      id: 'datagrid.toolbarDensityComfortable',
      defaultMessage: 'Geniş',
    }),

    // Columns selector toolbar button text
    toolbarColumns: intl.formatMessage({ id: 'datagrid.toolbarColumns', defaultMessage: 'Sütunlar' }),
    toolbarColumnsLabel: intl.formatMessage({ id: 'datagrid.toolbarColumnsLabel', defaultMessage: 'Sütunlar' }),

    // Filters toolbar button text
    toolbarFilters: intl.formatMessage({ id: 'datagrid.toolbarFilters', defaultMessage: 'Filtre' }),
    toolbarFiltersLabel: intl.formatMessage({ id: 'datagrid.toolbarFiltersLabel', defaultMessage: 'Filtre' }),
    toolbarFiltersTooltipHide: intl.formatMessage({
      id: 'datagrid.toolbarFiltersTooltipHide',
      defaultMessage: 'Filtreyi Gizle',
    }),
    toolbarFiltersTooltipShow: intl.formatMessage({
      id: 'datagrid.toolbarFiltersTooltipShow',
      defaultMessage: 'Filtreyi Göster',
    }),
    toolbarFiltersTooltipActive: (count: number) => {
      if (language === 'tr') {
        return `${count} Filtre Aktif`;
      }

      return count !== 1 ? `${count} Active Filters` : `${count} Active Filter`;
    },

    // Export selector toolbar button text
    toolbarExport: intl.formatMessage({ id: 'datagrid.toolbarExport', defaultMessage: 'İndir' }),
    toolbarExportLabel: intl.formatMessage({ id: 'datagrid.toolbarExportLabel', defaultMessage: 'İndir' }),
    toolbarExportCSV: intl.formatMessage({ id: 'datagrid.toolbarExportCSV', defaultMessage: 'CSV İndir' }),
    toolbarExportPrint: intl.formatMessage({ id: 'datagrid.toolbarExportPrint', defaultMessage: 'Yazdır' }),
    toolbarExportExcel: intl.formatMessage({ id: 'datagrid.toolbarExportExcel', defaultMessage: 'İndir' }),

    // Columns panel text
    columnsPanelTextFieldLabel: intl.formatMessage({
      id: 'datagrid.columnsPanelTextFieldLabel',
      defaultMessage: 'Sütun Bul',
    }),
    columnsPanelTextFieldPlaceholder: intl.formatMessage({
      id: 'datagrid.columnsPanelTextFieldPlaceholder',
      defaultMessage: 'Sütun Başlığı',
    }),
    columnsPanelShowAllButton: intl.formatMessage({
      id: 'datagrid.columnsPanelShowAllButton',
      defaultMessage: 'Tümünü Göster',
    }),
    columnsPanelHideAllButton: intl.formatMessage({
      id: 'datagrid.columnsPanelHideAllButton',
      defaultMessage: 'Tümünü Gizle',
    }),

    // Columns management text
    columnsManagementSearchTitle: intl.formatMessage({
      id: 'datagrid.columnsManagementSearchTitle',
      defaultMessage: 'Arama',
    }),
    columnsManagementNoColumns: intl.formatMessage({
      id: 'datagrid.columnsManagementNoColumns',
      defaultMessage: 'Sütun bulunamadı',
    }),
    columnsManagementShowHideAllText: intl.formatMessage({
      id: 'datagrid.columnsManagementShowHideAllText',
      defaultMessage: 'Tümünü Göster/Gizle',
    }),
    columnsManagementReset: intl.formatMessage({
      id: 'datagrid.columnsManagementReset',
      defaultMessage: 'Sıfırla',
    }),

    // Filter panel text
    filterPanelAddFilter: intl.formatMessage({ id: 'datagrid.filterPanelAddFilter', defaultMessage: 'Filtre Ekle' }),
    filterPanelRemoveAll: intl.formatMessage({ id: 'datagrid.filterPanelRemoveAll', defaultMessage: 'Tümünü Kaldır' }),
    filterPanelDeleteIconLabel: intl.formatMessage({
      id: 'datagrid.filterPanelDeleteIconLabel',
      defaultMessage: 'Sil',
    }),
    filterPanelOperator: intl.formatMessage({ id: 'datagrid.filterPanelOperator', defaultMessage: 'Operatör' }),
    filterPanelOperatorAnd: intl.formatMessage({ id: 'datagrid.filterPanelOperatorAnd', defaultMessage: 'Ve' }),
    filterPanelOperatorOr: intl.formatMessage({ id: 'datagrid.filterPanelOperatorOr', defaultMessage: 'Veya' }),
    filterPanelColumns: intl.formatMessage({ id: 'datagrid.filterPanelColumns', defaultMessage: 'Sütunlar' }),
    filterPanelInputLabel: intl.formatMessage({ id: 'datagrid.filterPanelInputLabel', defaultMessage: 'Değer' }),
    filterPanelInputPlaceholder: intl.formatMessage({
      id: 'datagrid.filterPanelInputPlaceholder',
      defaultMessage: 'Filtre Değeri',
    }),

    // Filter operators text
    filterOperatorContains: intl.formatMessage({ id: 'datagrid.filterOperatorContains', defaultMessage: 'içerir' }),
    filterOperatorDoesNotContain: intl.formatMessage({
      id: 'datagrid.filterOperatorDoesNotContain',
      defaultMessage: 'içermez',
    }),
    filterOperatorEquals: intl.formatMessage({ id: 'datagrid.filterOperatorEquals', defaultMessage: 'eşittir' }),
    filterOperatorDoesNotEqual: intl.formatMessage({
      id: 'datagrid.filterOperatorDoesNotEqual',
      defaultMessage: 'eşit değildir',
    }),
    filterOperatorStartsWith: intl.formatMessage({
      id: 'datagrid.filterOperatorStartsWith',
      defaultMessage: 'ile başlar',
    }),
    filterOperatorEndsWith: intl.formatMessage({ id: 'datagrid.filterOperatorEndsWith', defaultMessage: 'ile biter' }),
    filterOperatorIs: intl.formatMessage({ id: 'datagrid.filterOperatorIs', defaultMessage: 'denktir' }),
    filterOperatorIsEmpty: intl.formatMessage({ id: 'datagrid.filterOperatorIsEmpty', defaultMessage: 'boş olanlar' }),
    filterOperatorIsNotEmpty: intl.formatMessage({
      id: 'datagrid.filterOperatorIsNotEmpty',
      defaultMessage: 'boş olmayanlar',
    }),
    filterOperatorIsAnyOf: intl.formatMessage({ id: 'datagrid.filterOperatorIsAnyOf', defaultMessage: 'birden fazla' }),
    filterOperatorNot: intl.formatMessage({ id: 'datagrid.filterOperatorNot', defaultMessage: 'denk değildir' }),
    filterOperatorAfter: intl.formatMessage({ id: 'datagrid.filterOperatorAfter', defaultMessage: 'sonrasında' }),
    filterOperatorOnOrAfter: intl.formatMessage({
      id: 'datagrid.filterOperatorOnOrAfter',
      defaultMessage: 'denk ya da sonrasında',
    }),
    filterOperatorBefore: intl.formatMessage({ id: 'datagrid.filterOperatorBefore', defaultMessage: 'öncesinde' }),
    filterOperatorOnOrBefore: intl.formatMessage({
      id: 'datagrid.filterOperatorOnOrBefore',
      defaultMessage: 'denk ya da öncesinde',
    }),

    // Filter values text
    filterValueAny: intl.formatMessage({ id: 'datagrid.filterValueAny', defaultMessage: 'Tümü' }),
    filterValueTrue: intl.formatMessage({ id: 'datagrid.filterValueTrue', defaultMessage: 'Evet' }),
    filterValueFalse: intl.formatMessage({ id: 'datagrid.filterValueFalse', defaultMessage: 'Hayır' }),

    // Column menu text
    columnMenuLabel: intl.formatMessage({ id: 'datagrid.columnMenuLabel', defaultMessage: 'Menü' }),
    columnMenuShowColumns: intl.formatMessage({
      id: 'datagrid.columnMenuShowColumns',
      defaultMessage: 'Sütunları Göster',
    }),
    columnMenuManageColumns: intl.formatMessage({
      id: 'datagrid.columnMenuManageColumns',
      defaultMessage: 'Sütunları Düzenle',
    }),
    columnMenuFilter: intl.formatMessage({ id: 'datagrid.columnMenuFilter', defaultMessage: 'Filtre' }),
    columnMenuHideColumn: intl.formatMessage({
      id: 'datagrid.columnMenuHideColumn',
      defaultMessage: 'Sütunları Gizle',
    }),
    columnMenuUnsort: intl.formatMessage({ id: 'datagrid.columnMenuUnsort', defaultMessage: 'Sıralamayı İptal Et' }),
    columnMenuSortAsc: intl.formatMessage({ id: 'datagrid.columnMenuSortAsc', defaultMessage: 'Küçükten Büyüğe' }),
    columnMenuSortDesc: intl.formatMessage({ id: 'datagrid.columnMenuSortDesc', defaultMessage: 'Büyükten Küçüğe' }),

    // Column header text
    columnHeaderFiltersTooltipActive: (count: number) => {
      if (language === 'tr') {
        return `${count} Filtre Aktif`;
      }

      return count !== 1 ? `${count} Active Filters` : `${count} Active Filter`;
    },
    columnHeaderSortIconLabel: intl.formatMessage({
      id: 'datagrid.columnHeaderSortIconLabel',
      defaultMessage: 'Sırala',
    }),

    // Rows selected footer text
    footerRowSelected: (count: number) => {
      if (language === 'tr') {
        return `${count.toLocaleString()} satır seçildi`;
      }

      return count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`;
    },

    // Total row amount footer text
    footerTotalRows: intl.formatMessage({ id: 'datagrid.footerTotalRows', defaultMessage: 'Toplam Satır:' }),

    // Checkbox selection text
    checkboxSelectionHeaderName: intl.formatMessage({
      id: 'datagrid.checkboxSelectionHeaderName',
      defaultMessage: 'Onay Kutusu',
    }),
    checkboxSelectionSelectAllRows: intl.formatMessage({
      id: 'datagrid.checkboxSelectionSelectAllRows',
      defaultMessage: 'Tüm Satırları Seç',
    }),
    checkboxSelectionUnselectAllRows: intl.formatMessage({
      id: 'datagrid.checkboxSelectionUnselectAllRows',
      defaultMessage: 'Satır Seçimlerini Kaldır',
    }),
    checkboxSelectionSelectRow: intl.formatMessage({
      id: 'datagrid.checkboxSelectionSelectRow',
      defaultMessage: 'Satırı Seç',
    }),
    checkboxSelectionUnselectRow: intl.formatMessage({
      id: 'datagrid.checkboxSelectionUnselectRow',
      defaultMessage: 'Satır Seçimini Kaldır',
    }),

    // Boolean cell text
    booleanCellTrueLabel: intl.formatMessage({ id: 'datagrid.booleanCellTrueLabel', defaultMessage: 'Aktif' }),
    booleanCellFalseLabel: intl.formatMessage({ id: 'datagrid.booleanCellFalseLabel', defaultMessage: 'Pasif' }),

    // Column pinning text
    pinToLeft: intl.formatMessage({ id: 'datagrid.pinToLeft', defaultMessage: 'Sola sabitle' }),
    pinToRight: intl.formatMessage({ id: 'datagrid.pinToRight', defaultMessage: 'Sağa sabitle' }),
    unpin: intl.formatMessage({ id: 'datagrid.unpin', defaultMessage: 'Serbest bırak' }),

    // Master/detail
    detailPanelToggle: intl.formatMessage({ id: 'datagrid.detailPanelToggle', defaultMessage: 'Detay Paneli Geçişi' }),

    // Used core components translation keys
    MuiTablePagination: {
      labelRowsPerPage: intl.formatMessage({ id: 'datagrid.rowsPerPage', defaultMessage: 'Sayfa Başına Öğe:' }),
      showFirstButton: true,
      showLastButton: true,
      labelDisplayedRows: ({ from, to, count }: { from: number; to: number; count: number }) => {
        return language === 'en' ? `${from}-${to} of ${count}` : `${count} satırdan ${from}-${to} arası`;
      },
    },

    // Row reordering text
    rowReorderingHeaderName: intl.formatMessage({
      id: 'datagrid.rowReorderingHeaderName',
      defaultMessage: 'Row reordering',
    }),

    // Aggregation
    aggregationMenuItemHeader: intl.formatMessage({
      id: 'datagrid.aggregationMenuItemHeader',
      defaultMessage: 'Toplama',
    }),
    aggregationFunctionLabelSum: intl.formatMessage({
      id: 'datagrid.aggregationFunctionLabelSum',
      defaultMessage: 'top',
    }),
    aggregationFunctionLabelAvg: intl.formatMessage({
      id: 'datagrid.aggregationFunctionLabelAvg',
      defaultMessage: 'ort',
    }),
    aggregationFunctionLabelMin: intl.formatMessage({
      id: 'datagrid.aggregationFunctionLabelMin',
      defaultMessage: 'min',
    }),
    aggregationFunctionLabelMax: intl.formatMessage({
      id: 'datagrid.aggregationFunctionLabelMax',
      defaultMessage: 'maks',
    }),
    aggregationFunctionLabelSize: intl.formatMessage({
      id: 'datagrid.aggregationFunctionLabelSize',
      defaultMessage: 'boyut',
    }),
  };
};

export default renderDataGridLocaleText;
